import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { useApp } from "../context/AppContext";
import { toast } from "sonner";
import { Gift, Flame } from "lucide-react";

export default function DailyBonusCard() {
  const [status, setStatus] = useState(null);
  const [claiming, setClaiming] = useState(false);
  const { updateBalance } = useApp();

  const load = async () => {
    try { const r = await api.get("/bonus/daily/status"); setStatus(r.data); }
    catch {}
  };
  useEffect(() => { load(); }, []);

  const claim = async () => {
    setClaiming(true);
    try {
      const r = await api.post("/bonus/daily/claim");
      updateBalance("HUF", r.data.balance_huf);
      toast.success(`+${r.data.claimed.toLocaleString()} GC! Streak: ${r.data.streak} 🔥`);
      await load();
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Error");
    } finally { setClaiming(false); }
  };

  if (!status) return null;

  const nextAt = status.next_at ? new Date(status.next_at) : null;
  return (
    <div className="lux-card p-5 flex items-center gap-4" data-testid="daily-bonus-card">
      <div className="w-14 h-14 rounded-full flex items-center justify-center" style={{background:"radial-gradient(circle, #d4af37 0%, #6b4d0a 100%)"}}>
        <Gift className="text-black" size={26}/>
      </div>
      <div className="flex-1">
        <div className="text-xs uppercase tracking-widest text-[#d4af37]">Daily Bonus</div>
        <div className="font-serif text-xl">{status.amount.toLocaleString()} GC ingyen</div>
        {status.streak > 0 && (
          <div className="text-xs text-white/50 flex items-center gap-1 mt-1">
            <Flame size={12} className="text-orange-400"/>Streak: <span className="text-orange-400 font-bold">{status.streak}</span> nap · +500 GC bónusz minden nap
          </div>
        )}
      </div>
      {status.available ? (
        <button data-testid="claim-daily" onClick={claim} disabled={claiming} className="btn-gold px-6 py-3 rounded-md text-sm">
          {claiming ? "…" : "Claim"}
        </button>
      ) : (
        <div className="text-right">
          <div className="text-[10px] uppercase tracking-widest text-white/40">Next</div>
          <div className="text-xs text-white/70" data-testid="daily-bonus-cooldown">{nextAt?.toLocaleTimeString([], {hour:"2-digit",minute:"2-digit"})}</div>
        </div>
      )}
    </div>
  );
}
